import { PsResourceCompany } from './PsResourceCompany';
import { PsResourceDocumentSchema } from './PsResourceDocumentSchema';

export class PsResourceDocumentAssociation {

    _id; // number
    _contractor; // PsResourceCompany
    _documentSchema; // PsResourceDocumentSchema
    _position; // string

    constructor(
        id,
        contractor,
        documentSchema,
        position,
    ) {
        this._id = id;
        this._contractor = contractor;
        this._documentSchema = documentSchema;
        this._position = position;
    }

    static null() {
        return new this(
            -1,
            PsResourceCompany.null(true),
            PsResourceDocumentSchema.null(),
            null,
        );
    }

    static fromAPIResourceContractorSchemas(contractorSchemas) {
        return contractorSchemas.map((contractorSchema) =>
            PsResourceDocumentAssociation.fromAPIResourceContractorSchema(contractorSchema));
    }

    static fromAPIResourceContractorSchema(contractorSchema) {
        const { id, contractor, document_schema, position } = contractorSchema;

        return new this(
            id,
            contractor
                ? PsResourceCompany.fromAPIContractor(contractor)
                : PsResourceCompany.null(true),
            document_schema
                ? PsResourceDocumentSchema.fromAPIDocumentSchema(document_schema)
                : PsResourceDocumentSchema.null(),
            position,
        );
    }

    id() {
        return this._id;
    }

    contractor() {
        return this._contractor;
    }

    contractorId() {
        return this.contractor().id();
    }

    documentSchema() {
        return this._documentSchema;
    }

    documentSchemaId() {
        return this.documentSchema().id();
    }

    isMySchema(contractor) {
        return this.contractor().isMyContractor(contractor);
    }

    documentDescription() {
        return this.documentSchema().description();
    }

    completeDescription() {
        return  this.documentSchema().id() !== -1 ? `${this.contractor().description()} - ${this.documentSchema().description()}` : '';
    }

    completePosition() {
        return  this.documentSchema().id() !== -1 && this._position ? `${this.contractor().description()} - ${this._position}` : '';
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/model/resource/PsResourceDocumentAssociation.js